/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { EDITOR_REDUCER_NAME, CHOICE_KEYS, CHOICE_RESULT_KEYS } from './Constants';

import { getParamsToItemPropertyReducer } from './ItemController';

const getMaxId = processes => {
  const maxNextProcessId = Math.max(
    ...processes.flatMap(process =>
      process.choices.flatMap(choice => choice.results.map(result => result.nextProcessId)),
    ),
  );
  return maxNextProcessId === -Infinity ? 0 : maxNextProcessId;
};

const _generateChoiceResult = ({ resultId, nextProcessId }) => ({
  resultId,
  nextProcessId,
  changeStatus: {},
  resultPropertyChipState: {},
});

const _generateChoice = ({ choiceId, text = '', nextProcessId }) => ({
  choiceId,
  text,
  // results: [],
  // 변환

  results: [_generateChoiceResult({ resultId: 0, nextProcessId })],
  choicePropertyChipState: {},
});

const _generateProcess = ({ processId, choices, text = '', nextProcessId }) => ({
  processId,
  text,
  isEventFinish: false,
  choices: choices || [_generateChoice({ choiceId: 0, nextProcessId })],
});

const _generateAchievementModalProperty = () => ({
  isAchievementModalVisible: false,
  isUsingAchievementChip: false,
  isUsingEditMode: false,
});

const _generateAchievement = ({ id, title = '', description = '', condition = '' }) => ({
  id,
  title,
  description,
  condition,
});

const _generateAchievements = () => ({
  modal: _generateAchievementModalProperty(),
  chip: {},
  achievement: [],
});

const _getnerateHilight = () => ({
  hilightProcessId: null,
  highLightVisible: false,
});

const initialState = {
  projectId: null,
  selectedProcessId: 0,
  isUsingPageTabPress: false,
  processes: [_generateProcess({ processId: 0, nextProcessId: 1 })],
  achievements: _generateAchievements(),
  hilightProcess: _getnerateHilight(),
};

export const editorSlice = createSlice({
  name: EDITOR_REDUCER_NAME,
  initialState,
  reducers: {
    setInitialEditor: (state, { payload: { editor, projectId } }) => {
      return editor || { ...initialState, projectId };
    },

    setInitialProcess: () => {
      return initialState;
    },

    addEmptyAchievement: ({ achievements }) => {
      const maxId = Math.max(...achievements.achievement.map(item => item.id));
      const achievementId = achievements.achievement.length ? maxId + 1 : 0;

      const newAchievement = _generateAchievement({ id: achievementId });
      achievements.achievement.push(newAchievement);
    },

    addEmptyProcesses: ({ processes }) => {
      const maxNextProcessId = getMaxId(processes);
      const processId = processes.length;
      const newProcess = _generateProcess({ processId, nextProcessId: maxNextProcessId + 1 });

      processes.push(newProcess);
    },

    addEmptyProcessesHighLight: ({ hilightProcess, processes }) => {
      hilightProcess.hilightProcessId = processes[processes.length - 1].processId;
      hilightProcess.highLightVisible = true;
    },

    addMoveProcessHighLight: ({ hilightProcess }, { payload: { processId } }) => {
      hilightProcess.hilightProcessId = processId;
      hilightProcess.highLightVisible = true;
    },

    resetHilightProcess({ hilightProcess }) {
      hilightProcess.hilightProcessId = null;
      hilightProcess.highLightVisible = false;
    },

    addPageBetweenProcesses: ({ processes }, { payload: { processId } }) => {
      const findcurrentIndex = processes.findIndex(process => process.processId === processId);

      if (findcurrentIndex !== -1) {
        // 현재 위치에 새 프로세스 추가
        processes.splice(
          findcurrentIndex + 1,
          0,
          _generateProcess({ processId: findcurrentIndex + 1, nextProcessId: findcurrentIndex + 2 }),
        );

        // 새 프로세스 이후의 processId 업데이트
        for (let i = findcurrentIndex + 2; i < processes.length; i += 1) {
          processes[i].processId += 1;
        }

        // 모든 nextProcessId 업데이트
        const updateNextProcessIds = updatedProcesses => {
          updatedProcesses.forEach(process => {
            process.choices.forEach(choice => {
              choice.results.forEach(result => {
                if (result.nextProcessId > processId) {
                  result.nextProcessId += 1;
                }
              });
            });
          });
        };

        // 모든 nextProcessId를 갱신
        updateNextProcessIds(processes);
      }
    },

    // addPageBetweenProcesses: ({ processes }, { payload: { processId } }) => {
    //   const findcurrentIndex = processes.findIndex(process => process.processId === processId);

    //   if (findcurrentIndex !== -1) {
    //     processes.splice(
    //       findcurrentIndex + 1,
    //       0,
    //       _generateProcess({ processId: findcurrentIndex + 1, nextProcessId: findcurrentIndex + 2 }),
    //     );

    //     for (let i = findcurrentIndex + 2; i < processes.length; i += 1) {
    //       processes[i].processId += 1;

    //       processes[i].choices.forEach(choice => {
    //         choice.results.forEach(result => {
    //           if (result.nextProcessId > processId) {
    //             result.nextProcessId += 1;
    //           }
    //         });
    //       });
    //     }
    //   }
    // },

    addEmptyChoice: ({ processes }, { payload: { processId } }) => {
      // console.log('+ 버튼 클릭 addEmptyChoice');

      // const maxNextProcessId = Math.max(
      //   ...processes.flatMap(process =>
      //     process.choices.flatMap(choice => choice.results.map(result => result.nextProcessId)),
      //   ),
      // );

      const maxNextProcessId = getMaxId(processes);

      const newChoiceId = processes[processId].choices.length;

      // const targetProcess = processes[processId];
      processes[processId].choices.push(
        _generateChoice({ choiceId: newChoiceId, nextProcessId: maxNextProcessId + 1 }),
      );
    },

    addEmptyChoiceVisibleConditionItems: ({ processes }, { payload: { processId, choiceId } }) => {
      processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.HIDE] =
        processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.HIDE] || '';

      const choice = {
        [CHOICE_KEYS.HIDE]: {
          ifHaveNot: [
            {
              type: 'or',
              items: [],
            },
          ],
        },
      };

      Object.assign(processes[processId].choices[choiceId], choice);
    },

    addEmptyChoiceRequiredItems: ({ processes }, { payload: { processId, choiceId } }) => {
      processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.REQUIRED] =
        processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.REQUIRED] || '';

      const choice = {
        [CHOICE_KEYS.REQUIRED]: [],
      };

      Object.assign(processes[processId].choices[choiceId], choice);
    },

    addEmptyChoiceRequiredSponsorCookieItems: ({ processes }, { payload: { processId, choiceId } }) => {
      processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE] =
        processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE] || '1';

      const choice = {
        [CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE]: [],
      };
      Object.assign(processes[processId].choices[choiceId], choice);

      // processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE] =
      //   processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE] || '';

      // const choice = {
      //   [CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE]: [],
      // };
      // Object.assign(processes[processId].choices[choiceId], choice);
    },

    addEmptyChoiceResult: ({ processes }, { payload: { processId, choiceId } }) => {
      // console.log('분기추가 로직 addEmptyChoiceResult ');
      // const targetResults = processes[processId].choices[choiceId].results;
      // const newChoiceResultId = targetResults.length;

      // // console.log('targetResults:', current(targetResults));

      // targetResults.push(_generateChoiceResult({ resultId: newChoiceResultId, nextProcessId }));

      const maxNextProcessId = getMaxId(processes);

      // const targetProcess = processes[processId];
      // console.log('targetProcess:', current(targetProcess.processId));
      // 변환
      const targetResults = processes[processId].choices[choiceId].results;
      const defaultIndex = targetResults.findIndex(result => result.resultId === 0); // resultId가 0인 객체의 인덱스를 찾습니다.
      const newChoiceResultId = targetResults.length; // 새로운 객체의 resultId를 계산합니다.

      // 새로운 객체를 생성하고, 이를 resultId 0인 객체 앞에 추가합니다.
      processes[processId].choices[choiceId].results = [
        ...targetResults.slice(0, defaultIndex),
        _generateChoiceResult({ resultId: newChoiceResultId, nextProcessId: maxNextProcessId + 1 }),
        ...targetResults.slice(defaultIndex),
      ];
    },

    addEmptyChoiceResultStoreProperty: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
      // console.log(
      //   'processes[processId].choices[choiceId].results:',
      //   current(processes[processId].choices[choiceId].results),
      // );

      // processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[CHOICE_RESULT_KEYS.STORE] =
      //   processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[CHOICE_RESULT_KEYS.STORE] ||
      //   '';

      // 변환

      const processesResult = processes[processId].choices[choiceId].results;

      const findData = processesResult.find(v => v.resultId === resultId);

      const addFindData = findData || '';

      const result = {
        [CHOICE_RESULT_KEYS.STORE]: [],
        [CHOICE_RESULT_KEYS.STORE_HIDDEN]: [],
      };

      Object.assign(addFindData, result);
      // Object.assign(processes[processId].choices[choiceId].results[resultId], result);
    },

    addEmptyChoiceResultDestroyStoreProperty: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
      // processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[CHOICE_RESULT_KEYS.DESTROY] =
      //   processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[CHOICE_RESULT_KEYS.DESTROY] ||
      //   '';
      // 변환

      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);

      const result = {
        [CHOICE_RESULT_KEYS.DESTROY]: [],
        [CHOICE_RESULT_KEYS.DESTROY_HIDDEN]: [],
      };

      Object.assign(findData, result);
    },

    addEmptyResultProbabilityCondition: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
      // processes[processId].choices[choiceId].results[resultId][CHOICE_RESULT_KEYS.PROBABILITY] =
      //   processes[processId].choices[choiceId].results[resultId][CHOICE_RESULT_KEYS.PROBABILITY] || '';

      // processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[
      //   CHOICE_RESULT_KEYS.PROBABILITY
      // ] = true;
      // 변환

      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);

      findData[CHOICE_RESULT_KEYS.PROBABILITY] = findData[CHOICE_RESULT_KEYS.PROBABILITY] || '';

      findData.resultPropertyChipState[CHOICE_RESULT_KEYS.PROBABILITY] = true;
    },

    addEmptyResultRequiredItemsCondition: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
      // processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[
      //   CHOICE_RESULT_KEYS.REQUIRED_ITEMS
      // ] =
      //   processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[
      //     CHOICE_RESULT_KEYS.REQUIRED_ITEMS
      //   ] || '';

      // processes[processId].choices[choiceId].results[resultId][CHOICE_RESULT_KEYS.REQUIRED_ITEMS] = [];

      // 변환
      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);
      findData.resultPropertyChipState[CHOICE_RESULT_KEYS.REQUIRED_ITEMS] =
        findData.resultPropertyChipState[CHOICE_RESULT_KEYS.REQUIRED_ITEMS] || '';

      findData[CHOICE_RESULT_KEYS.REQUIRED_ITEMS] = [];
    },

    setAchievementModalStateByType: ({ achievements }, { payload: { type } }) => {
      achievements.modal[type] = !achievements.modal[type];
    },

    setAchievementChipState: ({ achievements }, { payload: chipState }) => {
      achievements.chip = { ...chipState };
    },

    setAllAchievementText: ({ achievements }, { payload: { achievement } }) => {
      achievements.achievement = achievement.map(item => item);
    },

    setAchievementTextByType: ({ achievements }, { payload: { achievementId, type, text } }) => {
      // achievements.achievement[achievementId][type] = text;

      const findAchive = achievements.achievement.find(v => v.id === achievementId);

      findAchive[type] = text;
    },

    setAchievementId: ({ processes }, { payload: { processId, choiceId, resultId, achievementId } }) => {
      // processes[processId].choices[choiceId].results[resultId].newAchievementId = achievementId;
      // 변환
      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);

      findData.newAchievementId = achievementId;
    },

    setSelectedProcessId: (state, { payload: { processId } }) => {
      state.selectedProcessId = processId;
    },

    setIsUsingPageTabPress: (state, { payload: { isUsingPageTabPress } }) => {
      state.isUsingPageTabPress = isUsingPageTabPress;
    },

    setProcess: ({ processes }, { payload: { processId, process } }) => {
      const targetProcess = processes[processId];

      Object.assign(targetProcess, process);
    },

    setProcessText: ({ processes }, { payload: { processId, text } }) => {
      processes[processId].text = text;
    },

    setChoiceText: ({ processes }, { payload: { processId, choiceId, text } }) => {
      processes[processId].choices[choiceId].text = text;
    },

    setChoiceResult: ({ processes }, { payload: { processId, choiceId, resultId, ...result } }) => {
      // Object.assign(processes[processId].choices[choiceId].results[resultId], result);

      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);
      Object.assign(findData, result);
    },

    setChoiceResultStoreProperty: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
      // const targetPropertyText =
      //   processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[CHOICE_RESULT_KEYS.STORE];
      // const { items: store, hiddenItems: storeHidden } = getParamsToItemPropertyReducer(targetPropertyText);
      // const result = { store, storeHidden };
      // Object.assign(processes[processId].choices[choiceId].results[resultId], result);

      // 변환

      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);

      const targetPropertyText = findData.resultPropertyChipState[CHOICE_RESULT_KEYS.STORE];
      const { items: store, hiddenItems: storeHidden } = getParamsToItemPropertyReducer(targetPropertyText);
      const result = { store, storeHidden };
      Object.assign(findData, result);
    },

    setChoiceResultDestroyProperty: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
      // const targetPropertyText =
      //   processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[CHOICE_RESULT_KEYS.DESTROY];

      // const { items: destroy, hiddenItems: destroyHidden } = getParamsToItemPropertyReducer(targetPropertyText);
      // const result = { destroy, destroyHidden };

      // Object.assign(processes[processId].choices[choiceId].results[resultId], result);

      // 변환
      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);
      const targetPropertyText = findData.resultPropertyChipState[CHOICE_RESULT_KEYS.DESTROY];

      const { items: destroy, hiddenItems: destroyHidden } = getParamsToItemPropertyReducer(targetPropertyText);
      const result = { destroy, destroyHidden };

      Object.assign(findData, result);
    },

    setChoiceVisibleConditionItems: ({ processes }, { payload: { processId, choiceId } }) => {
      // const targetChoiceVisibleConditionText =
      //   processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.HIDE];

      // const { items, hiddenItems } = getParamsToItemPropertyReducer(targetChoiceVisibleConditionText);
      // const targetItems = [...items, ...hiddenItems];

      // processes[processId].choices[choiceId].hide.ifHaveNot[0].items = targetItems;

      const targetChoiceVisibleConditionText =
        processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.HIDE];

      const { items, hiddenItems } = getParamsToItemPropertyReducer(targetChoiceVisibleConditionText);

      const targetItems = [...items, ...hiddenItems];

      processes[processId].choices[choiceId].hide.ifHaveNot[0].items = targetItems;
    },

    setChoiceRequired: ({ processes }, { payload: { processId, choiceId } }) => {
      const targetChoiceRequiredText =
        processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.REQUIRED];
      const { items, hiddenItems } = getParamsToItemPropertyReducer(targetChoiceRequiredText);
      const targetItems = [...items, ...hiddenItems];

      processes[processId].choices[choiceId][CHOICE_KEYS.REQUIRED] = targetItems;
    },

    setRequiredSponsorCookie: ({ processes }, { payload: { processId, choiceId } }) => {
      const targetRequiredSponsorCookie =
        processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE];
      const { items, hiddenItems } = getParamsToItemPropertyReducer(targetRequiredSponsorCookie);
      const targetItems = [...items, ...hiddenItems];

      processes[processId].choices[choiceId][CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE] = targetItems;
    },

    setIfs: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);

      const { items, hiddenItems } = getParamsToItemPropertyReducer(
        findData.resultPropertyChipState[CHOICE_RESULT_KEYS.REQUIRED_ITEMS],
      );
      const targetItems = [...items, ...hiddenItems];

      findData[CHOICE_RESULT_KEYS.REQUIRED_ITEMS] = targetItems;
    },

    setResultProbabilityCondition: ({ processes }, { payload: { processId, choiceId, resultId, probability } }) => {
      // processes[processId].choices[choiceId].results[resultId][CHOICE_RESULT_KEYS.PROBABILITY] = probability;
      // 변환
      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);

      findData[CHOICE_RESULT_KEYS.PROBABILITY] = probability;
    },

    setResultRequiredItemsCondition: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);

      const targetPropertyText = findData.resultPropertyChipState[CHOICE_RESULT_KEYS.REQUIRED_ITEMS];

      const { items, hiddenItems } = getParamsToItemPropertyReducer(targetPropertyText);
      const targetItems = [...items, ...hiddenItems];

      findData[CHOICE_RESULT_KEYS.REQUIRED_ITEMS] = targetItems;
    },

    setChangeStatus: ({ processes }, { payload: { processId, choiceId, resultId, status } }) => {
      // Object.assign(processes[processId].choices[choiceId].results[resultId].changeStatus, status);
      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);
      Object.assign(findData.changeStatus, status);
    },

    setIsEventFinish: ({ processes }, { payload: { processId } }) => {
      processes[processId].isEventFinish = !processes[processId].isEventFinish;
    },

    updateChoices: ({ processes }, { payload: { processId, afterItemIndex, beforeItemIndex } }) => {
      const removeChoice = processes[processId].choices.splice(beforeItemIndex, 1);

      processes[processId].choices.splice(afterItemIndex, 0, removeChoice[0]);

      processes[processId].choices.forEach((_, index) => {
        processes[processId].choices[index].choiceId = index;
      });
    },

    updateChoiceResults: ({ processes }, { payload: { processId, choiceId, afterItemIndex, beforeItemIndex } }) => {
      // const removeChoiceResult = processes[processId].choices[choiceId].results.splice(beforeItemIndex, 1);

      // processes[processId].choices[choiceId].results.splice(afterItemIndex, 0, removeChoiceResult[0]);

      // processes[processId].choices[choiceId].results.forEach((_, index) => {
      //   processes[processId].choices[choiceId].results[index].resultId = index;
      // });

      const removeChoiceResult = processes[processId].choices[choiceId].results.splice(beforeItemIndex, 1);
      processes[processId].choices[choiceId].results.splice(afterItemIndex, 0, removeChoiceResult[0]);

      processes[processId].choices[choiceId].results.forEach((v, index) => {
        processes[processId].choices[choiceId].results[index].resultId = v.resultId;
      });
    },

    updateChoicePropertyChipState: ({ processes }, { payload: { processId, choiceId, type, state } }) => {
      const processesChoice = processes[processId].choices[choiceId];

      processesChoice.choicePropertyChipState[type] = state;
      // processes[processId].choices[choiceId].choicePropertyChipState[type] = state;
    },

    updateResultPropertyChipState: ({ processes }, { payload: { processId, choiceId, resultId, type, state } }) => {
      // processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[type] = state;
      // 변환
      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);

      // console.log(
      //   'processes[processId].choices[choiceId].results[resultId]:',
      //   current(processes[processId].choices[choiceId].results[resultId]),
      // );

      // console.log('findDatas:', current(findDatas));

      // processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[type] = state;
      findData.resultPropertyChipState[type] = state;
    },

    deleteResultPropertyChipState: ({ processes }, { payload: { processId, choiceId, resultId, type } }) => {
      // delete processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[type];
      // if (type === CHOICE_RESULT_KEYS.CHANGE_STATUS) {
      //   processes[processId].choices[choiceId].results[resultId][type] = {};
      // } else {
      //   delete processes[processId].choices[choiceId].results[resultId][type];
      // }
      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);

      delete findData.resultPropertyChipState[type];
      if (type === CHOICE_RESULT_KEYS.CHANGE_STATUS) {
        findData[type] = {};
      } else {
        delete findData[type];
      }
    },

    duplicateAchievement: ({ achievements }, { payload: { achievementId } }) => {
      // const targetAchievement = achievements.achievement[achievementId];
      // const newAchievementId = achievements.achievement.length;
      // const newAchievement = { ...targetAchievement, id: newAchievementId };

      // achievements.achievement.push(newAchievement);

      const targetAchievement = achievements.achievement.find(item => item.id === achievementId);

      // const newAchievementId = achievements.achievement[achievements.achievement.length - 1].id + 1;

      const maxId = Math.max(...achievements.achievement.map(item => item.id));

      const newAchievement = { ...targetAchievement, id: maxId + 1 };

      achievements.achievement.push(newAchievement);
    },

    duplicateProcess: ({ processes }, { payload: { processId } }) => {
      const newProcessId = processes.length;
      const targetProcess = { ...processes[processId], processId: newProcessId };

      processes.push(targetProcess);
    },

    moveProcess: ({ processes }, { payload: { currentProcessId, targetPageId } }) => {
      const currentIndex = processes.findIndex(p => p.processId === currentProcessId);
      const targetIndex = processes.findIndex(p => p.processId === targetPageId);

      // Check if the currentProcessId and targetPageId are valid
      if (currentIndex !== -1 && targetIndex !== -1) {
        // Get the process that needs to be moved
        const movingProcess = processes[currentIndex];

        // Move the processes and update their processId
        if (currentIndex < targetIndex) {
          // Move processes down and update processId
          for (let i = currentIndex; i < targetIndex; i += 1) {
            processes[i] = processes[i + 1];
            processes[i].processId = i;
          }
        } else {
          // Move processes up and update processId
          for (let i = currentIndex; i > targetIndex; i -= 1) {
            processes[i] = processes[i - 1];
            processes[i].processId = i;
          }
        }

        // Place the moving process in the target position
        processes[targetIndex] = movingProcess;
        processes[targetIndex].processId = targetIndex;

        // Update all nextProcessId references to the moved process
        processes.forEach(process => {
          process.choices.forEach(choice => {
            choice.results.forEach(result => {
              if (result.nextProcessId === currentProcessId) {
                result.nextProcessId = targetPageId;
              } else if (currentIndex < targetIndex) {
                if (result.nextProcessId > currentIndex && result.nextProcessId <= targetIndex) {
                  result.nextProcessId -= 1;
                }
              } else if (result.nextProcessId >= targetIndex && result.nextProcessId < currentIndex) {
                result.nextProcessId += 1;
              }
            });
          });
        });
      }
    },

    // moveProcess: ({ processes }, { payload: { currentProcessId, targetPageId } }) => {
    //   const currentIndex = processes.findIndex(p => p.processId === currentProcessId);
    //   const targetIndex = processes.findIndex(p => p.processId === targetPageId);

    //   // Check if the currentProcessId and targetPageId are valid
    //   if (currentIndex !== -1 && targetIndex !== -1) {
    //     // Get the process that needs to be moved
    //     const movingProcess = processes[currentIndex];

    //     // Move the processes and update their processId
    //     if (currentIndex < targetIndex) {
    //       // 3에서 5으로 이동할 때
    //       for (let i = currentIndex; i < targetIndex; i += 1) {
    //         processes[i] = processes[i + 1];
    //         processes[i].processId = i;
    //       }
    //     } else {
    //       for (let i = currentIndex; i > targetIndex; i -= 1) {
    //         processes[i] = processes[i - 1];
    //         processes[i].processId = i;
    //       }
    //     }

    //     // Place the moving process in the target position
    //     processes[targetIndex] = movingProcess;
    //     processes[targetIndex].processId = targetIndex;
    //   }
    // },

    duplicateChoice: ({ processes }, { payload: { processId, choices } }) => {
      const newChoiceId = processes[processId].choices.length;
      const targetChoice = { ...choices, choiceId: newChoiceId };

      processes[processId].choices.push(targetChoice);
    },

    duplicateChoiceResult: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);

      const targetChoiceResults = findData;
      const newChoiceResultId = processes[processId].choices[choiceId].results.length;
      const targetChoiceResult = { ...targetChoiceResults, resultId: newChoiceResultId };

      const defaultIndex = processesResults.findIndex(result => result.resultId === 0); // resultId가 0인 객체의 인덱스를 찾습니다.

      processes[processId].choices[choiceId].results = [
        ...processesResults.slice(0, defaultIndex),
        targetChoiceResult,
        ...processesResults.slice(defaultIndex),
      ];
    },

    deleteAchievement: ({ achievements }, { payload: { achievementId } }) => {
      // achievements.achievement.splice(achievementId, 1);
      achievements.achievement = achievements.achievement.filter(item => item.id !== achievementId);
      // eslint-disable-next-line no-restricted-syntax
      // for (const item of achievements.achievement) {
      //   if (item.id > achievementId) {
      //     item.id -= 1;
      //   }
      // }
    },

    deleteAllEmptyPropertyAchievement: ({ achievements }) => {
      achievements.achievement = achievements.achievement.filter(
        ({ title, description, condition }) => !(!title && !description && !condition),
      );
    },

    deleteAchievementId: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
      // delete processes[processId].choices[choiceId].results[resultId].newAchievementId;
      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);
      delete findData.newAchievementId;
    },

    deleteAchievementIds: ({ processes }, { payload: { achievementId } }) => {
      processes.forEach(process => {
        process.choices.forEach(choice => {
          choice.results.forEach(result => {
            if (result.newAchievementId === achievementId) {
              delete result.newAchievementId;
            }
          });
        });
      });

      // const processesResults = processes[processId].choices[choiceId].results;
      // const findData = processesResults.find(v => v.resultId === resultId);
      // delete findData.newAchievementId;
    },

    deleteProcess: ({ processes }, { payload: { processId } }) => {
      processes.splice(processId, 1);
      // eslint-disable-next-line no-restricted-syntax
      for (const process of processes) {
        if (process.processId > processId) {
          process.processId -= 1;
        }
        for (const choice of process.choices) {
          for (const result of choice.results) {
            if (result.nextProcessId > processId) {
              result.nextProcessId -= 1;
            }
          }
        }
      }

      // processes.splice(processId, 1);
      // // eslint-disable-next-line no-restricted-syntax
      // for (const process of processes) {
      //   if (process.processId > processId) {
      //     process.processId -= 1;
      //   }
      // }
    },

    deleteAllChoices: ({ processes }, { payload: { processId } }) => {
      processes[processId].choices = [];
    },

    deleteChoice: ({ processes }, { payload: { processId, choiceId } }) => {
      processes[processId].choices.splice(choiceId, 1);
      // eslint-disable-next-line no-restricted-syntax
      for (const choice of processes[processId].choices) {
        if (choice.choiceId > choiceId) {
          choice.choiceId -= 1;
        }
      }
    },

    deleteChoiceResult: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
      // processes[processId].choices[choiceId].results.splice(resultId, 1);
      // // eslint-disable-next-line no-restricted-syntax
      // for (const result of processes[processId].choices[choiceId].results) {
      //   if (result.resultId > resultId) {
      //     result.resultId -= 1;
      //   }
      // }

      const processesResults = processes[processId].choices[choiceId].results;
      const findIndex = processesResults.findIndex(v => v.resultId === resultId);

      // const filterData = processesResults.filter(v => v.resultId !== resultId);

      processes[processId].choices[choiceId].results.splice(findIndex, 1);
      // eslint-disable-next-line no-restricted-syntax
      for (const result of processes[processId].choices[choiceId].results) {
        if (result.resultId > resultId) {
          result.resultId -= 1;
        }
      }
    },

    deleteChoiceResultProperty: ({ processes }, { payload: { processId, choiceId, resultId, type } }) => {
      // delete processes[processId].choices[choiceId].results[resultId][type];
      // delete processes[processId].choices[choiceId].results[resultId][CHOICE_RESULT_KEYS.RESULTPROPERTY_CHIPSTATE][
      //   type
      // ];
      const processesResults = processes[processId].choices[choiceId].results;
      const findData = processesResults.find(v => v.resultId === resultId);

      delete findData[type];
      delete findData[CHOICE_RESULT_KEYS.RESULTPROPERTY_CHIPSTATE][type];
    },

    // deleteChoiceResultPropertyChipState: (
    //   { processes },
    //   { payload: { processId, choiceId, resultId, type, property } },
    // ) => {
    //   delete processes[processId].choices[choiceId].results[resultId][type][property];
    // },

    deleteChoiceProperty: ({ processes }, { payload: { processId, choiceId, type } }) => {
      delete processes[processId].choices[choiceId][type];
      delete processes[processId].choices[choiceId][CHOICE_RESULT_KEYS.CHOICEPROPERTY_CHIPSTATE][type];
    },
  },
});

export const {
  setInitialEditor,
  addEmptyAchievement,
  addEmptyProcesses,
  addEmptyProcessesHighLight,
  addEmptyChoice,
  addEmptyChoiceVisibleConditionItems,
  addEmptyChoiceRequiredItems,
  addEmptyChoiceRequiredSponsorCookieItems,
  addEmptyChoiceResult,
  addEmptyChoiceResultStoreProperty,
  addEmptyChoiceResultDestroyStoreProperty,
  addEmptyResultProbabilityCondition,
  addEmptyResultRequiredItemsCondition,
  setAchievementModalStateByType,
  setAchievementId,
  setAchievementChipState,
  setAllAchievementText,
  setAchievementTextByType,
  setSelectedProcessId,
  setIsUsingPageTabPress,
  setProcess,
  setProcessText,
  setChoiceText,
  setChoiceResult,
  setChoiceResultStoreProperty,
  setChoiceResultDestroyProperty,
  setChoiceVisibleConditionItems,
  setChoiceRequired,
  setRequiredSponsorCookie,
  setResultProbabilityCondition,
  setResultRequiredItemsCondition,
  setChangeStatus,
  setIsEventFinish,
  updateChoices,
  updateChoiceResults,
  updateChoicePropertyChipState,
  updateResultPropertyChipState,
  duplicateAchievement,
  duplicateProcess,
  moveProcess,
  duplicateChoice,
  duplicateChoiceResult,
  deleteAllEmptyPropertyAchievement,
  deleteAchievementId,
  deleteAchievementIds,
  deleteAchievement,
  deleteProcess,
  deleteAllChoices,
  deleteChoice,
  deleteChoiceResult,

  deleteChoiceResultProperty,
  deleteChoiceProperty,
  deleteChoiceResultPropertyChipState,
  deleteResultPropertyChipState,
  setInitialProcess,
  setIfs,
  addPageBetweenProcesses,
  resetHilightProcess,
  addMoveProcessHighLight,
} = editorSlice.actions;

export default editorSlice.reducer;

// /* eslint-disable no-param-reassign */
// import { createSlice, current } from '@reduxjs/toolkit';

// import { EDITOR_REDUCER_NAME, CHOICE_KEYS, CHOICE_RESULT_KEYS } from './Constants';

// import { getParamsToItemPropertyReducer } from './ItemController';

// const _generateChoiceResult = ({ resultId, nextProcessId = 0 }) => ({
//   resultId,
//   nextProcessId,
//   changeStatus: {},
//   resultPropertyChipState: {},
// });

// const _generateChoice = ({ choiceId, text = '' }) => ({
//   choiceId,
//   text,
//   // results: [],
//   results: [_generateChoiceResult({ resultId: 0 })],
//   choicePropertyChipState: {},
// });

// const _generateProcess = ({ processId, choices, text = '' }) => ({
//   processId,
//   text,
//   isEventFinish: false,
//   choices: choices || [_generateChoice({ choiceId: 0 })],
// });

// const _generateAchievementModalProperty = () => ({
//   isAchievementModalVisible: false,
//   isUsingAchievementChip: false,
//   isUsingEditMode: false,
// });

// const _generateAchievement = ({ id, title = '', description = '', condition = '' }) => ({
//   id,
//   title,
//   description,
//   condition,
// });

// const _generateAchievements = () => ({
//   modal: _generateAchievementModalProperty(),
//   chip: {},
//   achievement: [],
// });

// const initialState = {
//   projectId: null,
//   selectedProcessId: 0,
//   isUsingPageTabPress: false,
//   processes: [_generateProcess({ processId: 0 })],
//   achievements: _generateAchievements(),
// };

// export const editorSlice = createSlice({
//   name: EDITOR_REDUCER_NAME,
//   initialState,
//   reducers: {
//     setInitialEditor: (state, { payload: { editor, projectId } }) => {
//       return editor || { ...initialState, projectId };
//     },

//     addEmptyAchievement: ({ achievements }) => {
//       const achievementId = achievements.achievement.length;
//       const newAchievement = _generateAchievement({ id: achievementId });

//       achievements.achievement.push(newAchievement);
//     },

//     addEmptyProcesses: ({ processes }) => {
//       const processId = processes.length;
//       const newProcess = _generateProcess({ processId });

//       processes.push(newProcess);
//     },

//     addEmptyChoice: ({ processes }, { payload: { processId } }) => {
//       const newChoiceId = processes[processId].choices.length;

//       processes[processId].choices.push(_generateChoice({ choiceId: newChoiceId }));
//     },

//     addEmptyChoiceVisibleConditionItems: ({ processes }, { payload: { processId, choiceId } }) => {
//       processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.HIDE] =
//         processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.HIDE] || '';

//       const choice = {
//         [CHOICE_KEYS.HIDE]: {
//           ifHaveNot: [
//             {
//               type: 'or',
//               items: [],
//             },
//           ],
//         },
//       };

//       Object.assign(processes[processId].choices[choiceId], choice);
//     },

//     addEmptyChoiceRequiredItems: ({ processes }, { payload: { processId, choiceId } }) => {
//       processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.REQUIRED] =
//         processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.REQUIRED] || '';

//       const choice = {
//         [CHOICE_KEYS.REQUIRED]: [],
//       };

//       Object.assign(processes[processId].choices[choiceId], choice);
//     },

//     addEmptyChoiceResult: ({ processes }, { payload: { processId, choiceId, nextProcessId } }) => {
//       const targetResults = processes[processId].choices[choiceId].results;
//       const newChoiceResultId = targetResults.length;

//       console.log('targetResults:', current(targetResults));

//       targetResults.push(_generateChoiceResult({ resultId: newChoiceResultId, nextProcessId }));

//       // const targetResults = processes[processId].choices[choiceId].results;
//       // const defaultIndex = targetResults.findIndex(result => result.resultId === 0); // resultId가 0인 객체의 인덱스를 찾습니다.
//       // const newChoiceResultId = targetResults.length; // 새로운 객체의 resultId를 계산합니다.

//       // // 새로운 객체를 생성하고, 이를 resultId 0인 객체 앞에 추가합니다.
//       // processes[processId].choices[choiceId].results = [
//       //   ...targetResults.slice(0, defaultIndex),
//       //   _generateChoiceResult({ resultId: newChoiceResultId, nextProcessId }),
//       //   ...targetResults.slice(defaultIndex),
//       // ];
//     },

//     addEmptyChoiceResultStoreProperty: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
//       processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[CHOICE_RESULT_KEYS.STORE] =
//         processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[CHOICE_RESULT_KEYS.STORE] ||
//         '';

//       const result = {
//         [CHOICE_RESULT_KEYS.STORE]: [],
//         [CHOICE_RESULT_KEYS.STORE_HIDDEN]: [],
//       };

//       Object.assign(processes[processId].choices[choiceId].results[resultId], result);
//     },

//     addEmptyChoiceResultDestroyStoreProperty: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
//       processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[CHOICE_RESULT_KEYS.DESTROY] =
//         processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[CHOICE_RESULT_KEYS.DESTROY] ||
//         '';

//       const result = {
//         [CHOICE_RESULT_KEYS.DESTROY]: [],
//         [CHOICE_RESULT_KEYS.DESTROY_HIDDEN]: [],
//       };

//       Object.assign(processes[processId].choices[choiceId].results[resultId], result);
//     },

//     addEmptyResultProbabilityCondition: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
//       processes[processId].choices[choiceId].results[resultId][CHOICE_RESULT_KEYS.PROBABILITY] =
//         processes[processId].choices[choiceId].results[resultId][CHOICE_RESULT_KEYS.PROBABILITY] || '';

//       processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[
//         CHOICE_RESULT_KEYS.PROBABILITY
//       ] = true;
//     },

//     addEmptyResultRequiredItemsCondition: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
//       processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[
//         CHOICE_RESULT_KEYS.REQUIRED_ITEMS
//       ] =
//         processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[
//           CHOICE_RESULT_KEYS.REQUIRED_ITEMS
//         ] || '';

//       processes[processId].choices[choiceId].results[resultId][CHOICE_RESULT_KEYS.REQUIRED_ITEMS] = [];
//     },

//     setAchievementModalStateByType: ({ achievements }, { payload: { type } }) => {
//       achievements.modal[type] = !achievements.modal[type];
//     },

//     setAchievementChipState: ({ achievements }, { payload: chipState }) => {
//       achievements.chip = { ...chipState };
//     },

//     setAllAchievementText: ({ achievements }, { payload: { achievement } }) => {
//       achievements.achievement = achievement.map(item => item);
//     },

//     setAchievementTextByType: ({ achievements }, { payload: { achievementId, type, text } }) => {
//       achievements.achievement[achievementId][type] = text;
//     },

//     setAchievementId: ({ processes }, { payload: { processId, choiceId, resultId, achievementId } }) => {
//       processes[processId].choices[choiceId].results[resultId].newAchievementId = achievementId;
//     },

//     setSelectedProcessId: (state, { payload: { processId } }) => {
//       state.selectedProcessId = processId;
//     },

//     setIsUsingPageTabPress: (state, { payload: { isUsingPageTabPress } }) => {
//       state.isUsingPageTabPress = isUsingPageTabPress;
//     },

//     setProcess: ({ processes }, { payload: { processId, process } }) => {
//       const targetProcess = processes[processId];

//       Object.assign(targetProcess, process);
//     },

//     setProcessText: ({ processes }, { payload: { processId, text } }) => {
//       processes[processId].text = text;
//     },

//     setChoiceText: ({ processes }, { payload: { processId, choiceId, text } }) => {
//       processes[processId].choices[choiceId].text = text;
//     },

//     setChoiceResult: ({ processes }, { payload: { processId, choiceId, resultId, ...result } }) => {
//       Object.assign(processes[processId].choices[choiceId].results[resultId], result);
//     },

//     setChoiceResultStoreProperty: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
//       const targetPropertyText =
//         processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[CHOICE_RESULT_KEYS.STORE];

//       const { items: store, hiddenItems: storeHidden } = getParamsToItemPropertyReducer(targetPropertyText);
//       const result = { store, storeHidden };

//       Object.assign(processes[processId].choices[choiceId].results[resultId], result);
//     },

//     setChoiceResultDestroyProperty: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
//       const targetPropertyText =
//         processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[CHOICE_RESULT_KEYS.DESTROY];

//       const { items: destroy, hiddenItems: destroyHidden } = getParamsToItemPropertyReducer(targetPropertyText);
//       const result = { destroy, destroyHidden };

//       Object.assign(processes[processId].choices[choiceId].results[resultId], result);
//     },

//     setChoiceVisibleConditionItems: ({ processes }, { payload: { processId, choiceId } }) => {
//       const targetChoiceVisibleConditionText =
//         processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.HIDE];

//       const { items, hiddenItems } = getParamsToItemPropertyReducer(targetChoiceVisibleConditionText);
//       const targetItems = [...items, ...hiddenItems];

//       processes[processId].choices[choiceId].hide.ifHaveNot[0].items = targetItems;
//     },

//     setChoiceRequired: ({ processes }, { payload: { processId, choiceId } }) => {
//       const targetChoiceRequiredText =
//         processes[processId].choices[choiceId].choicePropertyChipState[CHOICE_KEYS.REQUIRED];

//       const { items, hiddenItems } = getParamsToItemPropertyReducer(targetChoiceRequiredText);
//       const targetItems = [...items, ...hiddenItems];

//       processes[processId].choices[choiceId][CHOICE_KEYS.REQUIRED] = targetItems;
//     },

//     setResultProbabilityCondition: ({ processes }, { payload: { processId, choiceId, resultId, probability } }) => {
//       processes[processId].choices[choiceId].results[resultId][CHOICE_RESULT_KEYS.PROBABILITY] = probability;
//     },

//     setResultRequiredItemsCondition: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
//       const targetPropertyText =
//         processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[
//           CHOICE_RESULT_KEYS.REQUIRED_ITEMS
//         ];

//       const { items, hiddenItems } = getParamsToItemPropertyReducer(targetPropertyText);
//       const targetItems = [...items, ...hiddenItems];

//       processes[processId].choices[choiceId].results[resultId][CHOICE_RESULT_KEYS.REQUIRED_ITEMS] = targetItems;
//     },

//     setChangeStatus: ({ processes }, { payload: { processId, choiceId, resultId, status } }) => {
//       Object.assign(processes[processId].choices[choiceId].results[resultId].changeStatus, status);
//     },

//     setIsEventFinish: ({ processes }, { payload: { processId } }) => {
//       processes[processId].isEventFinish = !processes[processId].isEventFinish;
//     },

//     updateChoices: ({ processes }, { payload: { processId, afterItemIndex, beforeItemIndex } }) => {
//       const removeChoice = processes[processId].choices.splice(beforeItemIndex, 1);

//       processes[processId].choices.splice(afterItemIndex, 0, removeChoice[0]);

//       processes[processId].choices.forEach((_, index) => {
//         processes[processId].choices[index].choiceId = index;
//       });
//     },

//     updateChoiceResults: ({ processes }, { payload: { processId, choiceId, afterItemIndex, beforeItemIndex } }) => {
//       const removeChoiceResult = processes[processId].choices[choiceId].results.splice(beforeItemIndex, 1);

//       processes[processId].choices[choiceId].results.splice(afterItemIndex, 0, removeChoiceResult[0]);

//       processes[processId].choices[choiceId].results.forEach((_, index) => {
//         processes[processId].choices[choiceId].results[index].resultId = index;
//       });
//     },

//     updateChoicePropertyChipState: ({ processes }, { payload: { processId, choiceId, type, state } }) => {
//       processes[processId].choices[choiceId].choicePropertyChipState[type] = state;
//     },

//     updateResultPropertyChipState: ({ processes }, { payload: { processId, choiceId, resultId, type, state } }) => {
//       processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[type] = state;
//     },

//     deleteResultPropertyChipState: ({ processes }, { payload: { processId, choiceId, resultId, type } }) => {
//       delete processes[processId].choices[choiceId].results[resultId].resultPropertyChipState[type];
//       if (type === CHOICE_RESULT_KEYS.CHANGE_STATUS) {
//         processes[processId].choices[choiceId].results[resultId][type] = {};
//       } else {
//         delete processes[processId].choices[choiceId].results[resultId][type];
//       }
//     },

//     duplicateAchievement: ({ achievements }, { payload: { achievementId } }) => {
//       const targetAchievement = achievements.achievement[achievementId];
//       const newAchievementId = achievements.achievement.length;
//       const newAchievement = { ...targetAchievement, id: newAchievementId };

//       achievements.achievement.push(newAchievement);
//     },

//     duplicateProcess: ({ processes }, { payload: { processId } }) => {
//       const newProcessId = processes.length;
//       const targetProcess = { ...processes[processId], processId: newProcessId };

//       processes.push(targetProcess);
//     },

//     duplicateChoice: ({ processes }, { payload: { processId, choices } }) => {
//       const newChoiceId = processes[processId].choices.length;
//       const targetChoice = { ...choices, choiceId: newChoiceId };

//       processes[processId].choices.push(targetChoice);
//     },

//     duplicateChoiceResult: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
//       const targetChoiceResults = processes[processId].choices[choiceId].results[resultId];
//       const newChoiceResultId = processes[processId].choices[choiceId].results.length;
//       const targetChoiceResult = { ...targetChoiceResults, resultId: newChoiceResultId };

//       processes[processId].choices[choiceId].results.push(targetChoiceResult);
//     },

//     deleteAchievement: ({ achievements }, { payload: { achievementId } }) => {
//       achievements.achievement.splice(achievementId, 1);

//       // eslint-disable-next-line no-restricted-syntax
//       for (const item of achievements.achievement) {
//         if (item.id > achievementId) {
//           item.id -= 1;
//         }
//       }
//     },

//     deleteAllEmptyPropertyAchievement: ({ achievements }) => {
//       achievements.achievement = achievements.achievement.filter(
//         ({ title, description, condition }) => !(!title && !description && !condition),
//       );
//     },

//     deleteAchievementId: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
//       delete processes[processId].choices[choiceId].results[resultId].newAchievementId;
//     },

//     deleteProcess: ({ processes }, { payload: { processId } }) => {
//       processes.splice(processId, 1);
//       // eslint-disable-next-line no-restricted-syntax
//       for (const process of processes) {
//         if (process.processId > processId) {
//           process.processId -= 1;
//         }
//       }
//     },

//     deleteAllChoices: ({ processes }, { payload: { processId } }) => {
//       processes[processId].choices = [];
//     },

//     deleteChoice: ({ processes }, { payload: { processId, choiceId } }) => {
//       processes[processId].choices.splice(choiceId, 1);
//       // eslint-disable-next-line no-restricted-syntax
//       for (const choice of processes[processId].choices) {
//         if (choice.choiceId > choiceId) {
//           choice.choiceId -= 1;
//         }
//       }
//     },

//     deleteChoiceResult: ({ processes }, { payload: { processId, choiceId, resultId } }) => {
//       processes[processId].choices[choiceId].results.splice(resultId, 1);
//       // eslint-disable-next-line no-restricted-syntax
//       for (const result of processes[processId].choices[choiceId].results) {
//         if (result.resultId > resultId) {
//           result.resultId -= 1;
//         }
//       }
//     },

//     deleteChoiceResultProperty: ({ processes }, { payload: { processId, choiceId, resultId, type } }) => {
//       delete processes[processId].choices[choiceId].results[resultId][type];
//       delete processes[processId].choices[choiceId].results[resultId][CHOICE_RESULT_KEYS.RESULTPROPERTY_CHIPSTATE][
//         type
//       ];
//     },

//     // deleteChoiceResultPropertyChipState: (
//     //   { processes },
//     //   { payload: { processId, choiceId, resultId, type, property } },
//     // ) => {
//     //   delete processes[processId].choices[choiceId].results[resultId][type][property];
//     // },

//     deleteChoiceProperty: ({ processes }, { payload: { processId, choiceId, type } }) => {
//       delete processes[processId].choices[choiceId][type];
//       delete processes[processId].choices[choiceId][CHOICE_RESULT_KEYS.CHOICEPROPERTY_CHIPSTATE][type];
//     },
//   },
// });

// export const {
//   setInitialEditor,
//   addEmptyAchievement,
//   addEmptyProcesses,
//   addEmptyChoice,
//   addEmptyChoiceVisibleConditionItems,
//   addEmptyChoiceRequiredItems,
//   addEmptyChoiceResult,
//   addEmptyChoiceResultStoreProperty,
//   addEmptyChoiceResultDestroyStoreProperty,
//   addEmptyResultProbabilityCondition,
//   addEmptyResultRequiredItemsCondition,
//   setAchievementModalStateByType,
//   setAchievementId,
//   setAchievementChipState,
//   setAllAchievementText,
//   setAchievementTextByType,
//   setSelectedProcessId,
//   setIsUsingPageTabPress,
//   setProcess,
//   setProcessText,
//   setChoiceText,
//   setChoiceResult,
//   setChoiceResultStoreProperty,
//   setChoiceResultDestroyProperty,
//   setChoiceVisibleConditionItems,
//   setChoiceRequired,
//   setResultProbabilityCondition,
//   setResultRequiredItemsCondition,
//   setChangeStatus,
//   setIsEventFinish,
//   updateChoices,
//   updateChoiceResults,
//   updateChoicePropertyChipState,
//   updateResultPropertyChipState,
//   duplicateAchievement,
//   duplicateProcess,
//   duplicateChoice,
//   duplicateChoiceResult,
//   deleteAllEmptyPropertyAchievement,
//   deleteAchievementId,
//   deleteAchievement,
//   deleteProcess,
//   deleteAllChoices,
//   deleteChoice,
//   deleteChoiceResult,

//   deleteChoiceResultProperty,
//   deleteChoiceProperty,
//   deleteChoiceResultPropertyChipState,
//   deleteResultPropertyChipState,
// } = editorSlice.actions;

// export default editorSlice.reducer;
